<template>
  <div>
    <el-card :body-style="cardBodyStyle">
      <el-form label-width="80px" :inline="true" ref="form" :model="form" :rules="formRules">
        <el-form-item label="数据库" prop="tableName">
          <el-input v-model="dbType" size="small" style="width: 200px; " disabled>
          </el-input>
        </el-form-item>
        <el-form-item label="表名" prop="tableName">
          <el-input v-model="form.tableName" @input="handleInputTableName" size="small" style="width: 200px;">
          </el-input>
        </el-form-item>
        <el-form-item label="服务名" prop="moduleName">
          <el-input v-model="form.moduleName" size="small" placeholder="test" style="width: 200px;"
            @input="handleModuleNameInput">
          </el-input>
        </el-form-item>
        <!--        <el-form-item label="微服务名" prop="serviceName">
          <el-input v-model="form.serviceName" size="small" placeholder="service-test" style="width: 200px;">
          </el-input>
        </el-form-item> -->
        <!--        <el-form-item class="no-show-error-message">
          <el-button size="mini" type="primary" @click="handleCheck( )">检查</el-button>
        </el-form-item>
        <el-form-item class="no-show-error-message">
          <el-button size="mini" type="success" @click="handleSearch()">查询</el-button>
        </el-form-item>
        <el-form-item class="no-show-error-message">
          <el-button size="mini" type="warning" @click="handleCreateTable()">生成</el-button>
        </el-form-item> -->
      </el-form>
    </el-card>

    <el-card :body-style="cardBodyStyle">
      <el-button size="mini" @click="handleQueryDBType('form')">检测数据库</el-button>
      <el-button size="mini" type="info" @click="handleQueryDB('form')">读取数据库</el-button>
      <el-button size="mini" type="primary" @click="handleSearch('form')">查询</el-button>
      <el-button size="mini" type="warning" @click="handleAddField()">添加字段</el-button>
      <el-button size="mini" type="danger" @click="handleAddDefault()">添加默认字段</el-button>
      <el-button size="mini" type="success" @click="handleSave('form')">保存</el-button>
      <el-button size="mini" type="success" @click="handleCreate('form')">建表</el-button>
      <el-button size="mini" type="success" @click="handleCreateSqlOracle('form')">sql-oracle</el-button>
      <el-button size="mini" type="success" @click="handleCreateSqlMysql('form')">sql-mysql</el-button>
    </el-card>

    <el-card :body-style="cardBodyStyle">
      <el-table :data="tableData" ref="tableData" border height="650px" highlight-current-row
        :row-class-name="tableRowClassName" @current-change="handleCurrentChange">
        <el-table-column type="index" label="序号" align="center" width="60">
        </el-table-column>
        <!--        <el-table-column prop="sort" label="sort" align="center" width="60">
        </el-table-column> -->
        <el-table-column prop="id" label="id" width="60" header-align="center" align="center" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="fieldName" label="字段名" width="140" header-align="center" align="center"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="fieldComment" label="注释" width="140" header-align="center" align="center"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="fieldType" label="字段类型" width="140" header-align="center" align="center"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="dataLength" label="长度" width="80" header-align="center" align="center"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="dataPrecision" label="精度" width="80" header-align="center" align="center"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="nullFlag" label="非空" width="80" header-align="center" align="center"
          show-overflow-tooltip>
          <template slot-scope="scope">
            <el-checkbox v-model="scope.row.nullFlag" disabled true-label="1" false-label="0"></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column prop="pkFlag" label="主键" width="80" header-align="center" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-checkbox v-model="scope.row.pkFlag" disabled true-label="1" false-label="0"></el-checkbox>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="260px" header-align="center" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" icon="el-icon-top" circle @click="handleUp(scope.row,scope.$index)">
            </el-button>
            <el-button size="mini" type="primary" icon="el-icon-bottom" circle
              @click="handleDown(scope.row,scope.$index)">
            </el-button>
            <el-button size="mini" type="warning" @click="handleEdit(scope.$index,scope.row )">编辑</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.$index,scope.row )">删除</el-button>
          </template>
        </el-table-column>


      </el-table>
    </el-card>


    <el-dialog :close-on-click-modal="false" v-dialogDrag :visible.sync="dialogVisible" width="700px">
      <el-form label-width="80px" :inline="true" ref="tableField" :model="tableField" :rules="tableFieldRules">
        <el-form-item label="字段名" prop="fieldName">
          <el-input v-model="tableField.fieldName" @input="handleInputFieldName" size="small" class="sx-formitem-width">
          </el-input>
        </el-form-item>
        <el-form-item label="注释" prop="fieldComment">
          <el-input v-model="tableField.fieldComment" size="small" class="sx-formitem-width">
          </el-input>
        </el-form-item>
        <el-form-item label="字段类型">
          <el-select v-model="tableField.fieldType" size="small" class="sx-formitem-width">
            <el-option v-for="item in fieldTypeOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <!--        <el-form-item label="主键">
          <el-checkbox v-model="tableField.pkFlag" true-label="1" false-label="0"></el-checkbox>
        </el-form-item> -->
        <el-form-item label="非空">
          <el-checkbox v-model="tableField.nullFlag" true-label="1" false-label="0"></el-checkbox>
        </el-form-item>
        <el-form-item label="长度">
          <el-input-number v-model="tableField.dataLength" :min="0" size="small" style="width: 120px;">
          </el-input-number>
        </el-form-item>
        <el-form-item label="精度">
          <el-input-number v-model="tableField.dataPrecision" :min="0" size="small" style="width: 120px;">
          </el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" type="success" @click="handleComfirm('tableField')">确定</el-button>
        <el-button size="small" type="danger" @click="handleComfirmCancel">取消</el-button>
      </span>
    </el-dialog>



  </div>
</template>

<script>
  import tools from '@/tools'
  import axios from '@/axios'
  export default {
    data() {
      return {
        cardBodyStyle: tools.style.card,
        form: {
          // tableName: 'T_TEST_LEE',
          // tablePrefix: 'T_TEST',
          // moduleName: 'test',
          // serviceName: 'service-test',
          // parentPackageName: 'com.shinsoft.servicetest',
          // processKey: '',
          // vuePath: 'C:\\workspaces\\sgiip\\Proj_SgIIP_Src_vue',

          tableName: '',
          tablePrefix: '',
          moduleName: '',
          serviceName: '',
          parentPackageName: '',
          processKey: '',
          vuePath: '',

        },
        formRules: {
          tableName: [{
            required: true,
            message: '不能为空',
            trigger: 'blur,change'
          }],
          moduleName: [{
            required: true,
            message: '不能为空',
            trigger: 'blur,change'
          }],
          serviceName: [{
            required: true,
            message: '不能为空',
            trigger: 'blur,change'
          }],
        },
        tableFieldRules: {
          fieldName: [{
            required: true,
            message: '不能为空',
            trigger: 'blur,change'
          }],
          fieldComment: [{
            required: true,
            message: '不能为空',
            trigger: 'blur,change'
          }],
        },
        tableData: [],
        addDefaultFlag: false,
        tableField: {
          fieldName: '',
          fieldType: 'VARCHAR2',
          fieldComment: '',
          dataLength: 0,
          dataPrecision: 0,
          nullFlag: '0',
          pkFlag: '0',

          controllerType: '',
          inputFlag: false,
          requireFlag: false,

          queryFlag: false,
          fuzzyFlag: false,
          dateFlag: false,
        },
        fieldTypeOptions: [{
          value: 'VARCHAR2',
          label: 'VARCHAR2'
        }, {
          value: 'NUMBER',
          label: 'NUMBER'
        }, {
          value: 'DATE',
          label: 'DATE'
        }],
        dialogVisible: false,
        selectedRowIndex: 0,
        dbType: ''
      }

    },
    methods: {

      handleQueryDB(form) {
        this.$refs[form].validate((valid) => {
          if (valid) {
            var url = this.form.moduleName + '/Generate/query.do'
            var param = {
              tableName: this.form.tableName
            }
            axios.post(url, param).then(response => {
              if (response.data.code == 0) {
                this.tableData = response.data.data
              } else {
                this.$message({
                  type: 'error',
                  message: '操作失败!' + response.data.msg
                });
                this.tableData = []
              }
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        })
      },
      handleCheck(form) {
        this.$refs[form].validate((valid) => {
          if (valid) {
            var url = this.form.moduleName + '/Generate/check.do'
            var param = {
              tableName: this.form.tableName
            }
            axios.post(url, param).then(response => {
              if (response.data.code == 0) {
                this.$message({
                  type: 'success',
                  message: response.data.data
                });
              } else {
                this.$message({
                  type: 'error',
                  message: '操作失败!' + response.data.msg
                });
              }
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        })

      },
      handleSearch(form) {
        this.$refs[form].validate((valid) => {
          if (valid) {
            var url = 'framework/TableField/query.do'
            var param = {
              tableName: this.form.tableName
            }
            axios.post(url, param).then(response => {
              if (response.data.code == 0) {
                this.form.tablePrefix = response.data.data[0].tablePrefix
                this.form.moduleName = response.data.data[0].moduleName
                this.form.serviceName = response.data.data[0].serviceName
                this.form.parentPackageName = response.data.data[0].parentPackageName
                this.form.processKey = response.data.data[0].processKey
                this.form.vuePath = response.data.data[0].vuePath
                this.tableData = response.data.data
              } else {
                this.$message({
                  type: 'error',
                  message: '操作失败!' + response.data.msg
                });
                this.tableData = []
              }
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        })
      },
      handleSave(form) {
        this.$refs[form].validate((valid) => {
          if (valid) {
            var url = 'framework/TableField/save.do'
            var param = {
              tableName: this.form.tableName,
              tablePrefix: this.form.tablePrefix,
              moduleName: this.form.moduleName,
              serviceName: this.form.serviceName,
              parentPackageName: this.form.parentPackageName,
              json: JSON.stringify(this.tableData)
            }
            axios.post(url, param).then(response => {
              if (response.data.code == 0) {
                this.$message({
                  type: 'success',
                  message: '操作成功!'
                });
                this.handleSearch(form)
              } else {
                this.$message({
                  type: 'error',
                  message: '操作失败!' + response.data.msg
                });
              }
            })

          } else {
            console.log('error submit!!');
            return false;
          }
        })

      },

      handleAddField() {
        if (this.dbType == null || this.dbType == '') {
          this.$message({
            type: 'error',
            message: '请先检测数据库!'
          });
          return
        }


        this.tableField = {
            fieldName: '',
            fieldType: '',
            fieldComment: '',
            dataLength: 0,
            dataPrecision: 0,
            nullFlag: '0',
            pkFlag: '0',
          },
          this.dialogVisible = true
      },
      handleAddDefault() {
        if (this.dbType == null || this.dbType == '') {
          this.$message({
            type: 'error',
            message: '请先检测数据库!'
          });
          return
        }

        var url = 'framework/TableField/queryDefault.do'
        var param = {
          dbType: this.dbType
        }
        axios.post(url, param).then(response => {
          if (response.data.code == 0) { 
            this.tableData = this.tableData.concat(response.data.data)
          } else {
            this.$message({
              type: 'error',
              message: '操作失败!' + response.data.msg
            });
          }
        })
      },
      handleComfirm(tableField) {
        this.$refs[tableField].validate((valid) => {
          if (valid) {
            if (this.tableField.id == null || this.tableField.id == '') {
              this.tableData.splice(this.selectedRowIndex, 0, this.tableField)
            }
            this.dialogVisible = false
          } else {
            console.log('error submit!!');
            return false;
          }
        })
      },
      handleComfirmCancel() {
        this.dialogVisible = false
      },
      handleEdit(index, row) {
        this.tableField = row
        this.dialogVisible = true
      },

      handleDelete(index, row) {
        this.tableData.splice(index, 1)

        var url = 'framework/TableField/remove.do'
        var param = {
          id: row.id,
        }
        axios.post(url, param).then(response => {
          if (response.data.code == 0) {

          } else {
            this.$message({
              type: 'error',
              message: '操作失败!' + response.data.msg
            });
          }
        })
      },
      handleCreate(form) {
        this.$refs[form].validate((valid) => {
          if (valid) {
            var url = this.form.moduleName + '/Generate/create.do'
            var param = {
              tableName: this.form.tableName,
              tablePrefix: this.form.tablePrefix,
              moduleName: this.form.moduleName,
              serviceName: this.form.serviceName,
              parentPackageName: this.form.parentPackageName,
              json: JSON.stringify(this.tableData)
            }
            axios.post(url, param).then(response => {
              if (response.data.code == 0) {
                this.$message({
                  type: 'success',
                  message: response.data.data
                });
              } else {
                this.$message({
                  type: 'error',
                  message: '操作失败!' + response.data.msg
                });
              }
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        })
      },


      handleCreateSqlOracle(form) {
        this.createSql(form, 'oracle')
      },
      handleCreateSqlMysql(form) {
        this.createSql(form, 'mysql')
      },
      createSql(form, type) {
        this.$refs[form].validate((valid) => {
          if (valid) {
            var url = this.form.moduleName + '/Generate/createSql.do'
            var param = {
              tableName: this.form.tableName,
              tablePrefix: this.form.tablePrefix,
              moduleName: this.form.moduleName,
              serviceName: this.form.serviceName,
              parentPackageName: this.form.parentPackageName,
              json: JSON.stringify(this.tableData),
              type: type
            }
            axios.post(url, param).then(response => {
              if (response.data.code == 0) {
                this.$message({
                  type: 'success',
                  message: response.data.data
                });
              } else {
                this.$message({
                  type: 'error',
                  message: '操作失败!' + response.data.msg
                });
              }
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        })
      },



      handleModuleNameInput(value) {
        this.form.parentPackageName = 'com.shinsoft.' + value
        this.form.serviceName = '' + value

      },


      handleInputTableName(value) {
        this.form.tableName = value.toUpperCase()
      },
      handleInputFieldName(value) {
        this.tableField.fieldName = value.toUpperCase()
      },

      handleUp(row, index) {
        if (index == 0) {
          return
        }
        var temp = row
        this.tableData.splice(index, 1)
        this.tableData.splice(index - 1, 0, temp)
      },
      handleDown(row, index) {
        if (index == this.tableData.length - 1) {
          return
        }
        var temp = row
        this.tableData.splice(index, 1)
        this.tableData.splice(index + 1, 0, temp)
      },
      tableRowClassName({
        row,
        rowIndex
      }) {
        row.sort = rowIndex + 1;
      },
      handleCurrentChange(val) {
        if (val) {
          this.selectedRowIndex = val.sort
        } else {
          this.selectedRowIndex = 0
        }

      },
      handleQueryDBType(form) {
        this.$refs[form].validate((valid) => {
          if (valid) {
            var url = this.form.moduleName + '/Generate/queryDBType.do'
            var param = {}
            axios.get(url, param).then(response => {
              if (response.data.code == 0) {
                this.$message({
                  type: 'success',
                  message: response.data.data
                });
                this.dbType = response.data.data

                if (this.dbType == 'oracle') {

                  this.fieldTypeOptions = [{
                    value: 'VARCHAR2',
                    label: 'VARCHAR2'
                  }, {
                    value: 'NUMBER',
                    label: 'NUMBER'
                  }, {
                    value: 'DATE',
                    label: 'DATE'
                  }]
                } else if (this.dbType == 'mysql') {

                  this.fieldTypeOptions = [{
                    value: 'varchar',
                    label: 'varchar'
                  }, {
                    value: 'int',
                    label: 'int'
                  }, {
                    value: 'float',
                    label: 'float'
                  }, {
                    value: 'double',
                    label: 'double'
                  }, {
                    value: 'date',
                    label: 'date'
                  }, {
                    value: 'datetime',
                    label: 'datetime'
                  }]
                }



              } else {
                this.$message({
                  type: 'error',
                  message: '操作失败!' + response.data.code + response.data.msg + response.data.fullMsg +
                    response.data.data
                });
              }
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        })
      },

    },
    mounted() {

    }


  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/view/generater/table.vue